import React, {useState} from "react";
import Button from './modules/Button';
import SocialLinksModal from './SocialLinksModal';
import { trackClick } from "./modules/TrackingLink"

const SocialLinks = ({ scorecard }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button className="mini" onClick={ () => {
          setShowModal(true);
          trackClick("open_social_modal");
        }}><i className="fa fa-share"></i> Share This Degree</Button>
      <SocialLinksModal active={showModal} scorecard={ scorecard } onDismiss={ ()=> setShowModal(false) }/>
    </>
  );
};

SocialLinks.defaultProps = {
  scorecard: {
    school: "none",
    unitid: 0,
    cipCode: 0,
    degreeLevel: 0
  }
};

export default SocialLinks;
